import React, { useRef, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import FlexView from 'react-flexview/lib';

import * as actions from '../../store/actions/churgerBuilderActions';
import fries from '../../assets/images/fries.png';

import { gsap, TweenMax } from 'gsap';
import { CustomEase } from 'gsap/CustomEase';
gsap.registerPlugin(CustomEase);

export default function Drawer() {
	let drawer = useRef();

	useEffect(() => {
		TweenMax.from(drawer, 0.7, {
			y: -800,
			ease: CustomEase.create(
				'custom',
				'M0,0 C0.14,0 0.242,0.438 0.272,0.561 0.313,0.728 0.354,0.963 0.362,1 0.37,0.985 0.45,0.852 0.498,0.811 0.574,0.745 0.665,0.768 0.68,0.774 0.768,0.804 0.818,0.985 0.832,0.998 0.843,0.994 0.913,0.944 0.928,0.944 0.943,0.944 1,1 1,1 '
			),
		});
	});

	const fryClickHandler = () => {
		dispatch(actions.setDrawer(false));
		dispatch(actions.setFXPlaying('pop'));
	};

	const dispatch = useDispatch();
	return (
		<FlexView column className="Drawer" ref={(el) => (drawer = el)}>
			<img src={fries} alt="X" id="DrawerX" onClick={fryClickHandler} />
			<NavLink
				to="/"
				className="DrawerLink"
				onClick={() => dispatch(actions.setDrawer(false))}
			>
				Home
			</NavLink>
			<NavLink
				to="/menu"
				className="DrawerLink"
				onClick={() => dispatch(actions.setDrawer(false))}
			>
				Our Menu
			</NavLink>
			<NavLink
				to="/about"
				className="DrawerLink"
				onClick={() => dispatch(actions.setDrawer(false))}
			>
				About Our Food
			</NavLink>
			<NavLink
				to="/order"
				className="DrawerLink"
				onClick={() => dispatch(actions.setDrawer(false))}
			>
				Order Now
			</NavLink>
			<NavLink
				to="/halp"
				className="DrawerLink"
				onClick={() => dispatch(actions.setDrawer(false))}
			>
				Halp
			</NavLink>
		</FlexView>
	);
}
